import {AppState} from 'redux/config'

export const select_speedBump = (state: AppState) => state.speedBump
